export const validatePassword = (password) => {
    // Check if password is at least 8 characters long
    if (password.length < 8) {
      return false;
    }
  
 
  let character = false
  for (let i = 0; i < password.length; i++) {
    const char = password.charAt(i);
    if ((char >= "a" && char <= "z") || (char >= "A" && char <= "Z")) {
      character = true
    }
  }
  if (!character) {
    return false;
  }
    
  
    // Check if password contains at least one digit
    let hasDigit = false;
    for (const char of password) {
      if (!isNaN(char)) {
        hasDigit = true;
        break;
      }
    }
    if (!hasDigit) {
      return false;
    }
    
    let specialCharater = hasSpecialCharacter(password)

    return specialCharater;
  }


  const hasSpecialCharacter = (str) =>{
    const specialChars = "~!@#$%^&*_-+=`|\\()[]:;\"'<>,.?/"; 
    for (let i = 0; i < str.length; i++) {
      if (specialChars.indexOf(str[i]) !== -1) {
        return true; // Special character found
      }
    }
    return false; // Special character not found
  }